import { TmTableError } from '@/core/error/table/tmTableError'

export class TmTableSortError extends TmTableError {
  public name = 'TmTableSortError'
}
